import { render, staticRenderFns } from "./PermissionRole.vue?vue&type=template&id=0574873a&scoped=true"
import script from "./PermissionRole.vue?vue&type=script&lang=js"
export * from "./PermissionRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574873a",
  null
  
)

export default component.exports